function countMatches(arr, key, value) {
  if (!Array.isArray(arr)) return 0;

  return arr.reduce((count, obj) => {
    return obj && obj[key] === value ? count + 1 : count;
  }, 0);
}

export default countMatches;
